import script from "./solutionDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./solutionDetail.vue?vue&type=script&setup=true&lang=js"

import "./solutionDetail.vue?vue&type=style&index=0&id=8e7530ae&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e7530ae"]])

export default __exports__